import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link, useLocation } from "react-router-dom";
import withRouter from "../withRouter";
import axios from "axios";
import md5 from "md5";
import {
  Typography,
  TextField,
  Box,
  Avatar,
  Divider,
  Card,
  CardContent,
  IconButton,
  InputAdornment,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  Checkbox,
} from "@mui/material";
import { Lock, Visibility, VisibilityOff } from "@mui/icons-material";
import Rights from "../../../Pages/Modules/Rights";

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);
  const location = useLocation();
  const _userId = localStorage.getItem("UserId");

  const userNameLocal = localStorage.getItem("UserName");
  const UserTypeLocal = localStorage.getItem("User_Type");
  const EfaxLocal = localStorage.getItem("Efax");
  const photoUrl = localStorage.getItem("photoUrl");
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = { Authorization: auth };
  const [admins, setAdmins] = useState([]);
  const [Imagebase64, setImagebase64] = useState("");
  const [profileModal, setProfileModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const defaultpracticeId = localStorage.getItem("default_paractice");
  const [userData, setUserData] = useState(null);
  const [roleId, setRoleId] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [NewsLetters, setNewsLetters] = useState(true);
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/Module/Roles?defaultpracticeId=${defaultpracticeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        const roles = response;
        const matchedRole = roles.find(
          (role) =>
            role.name.trim().toLowerCase() ===
            UserTypeLocal.trim().toLowerCase()
        );
        if (matchedRole) {
          console.log("Matched Role:", matchedRole);
          setRoleId(matchedRole.id);
        } else {
          console.warn("No role matched for:", UserTypeLocal);
          setRoleId(null);
        }
      })
      .catch((error) => {
        console.error("Error fetching referring physicians:", error);
      });
  }, [UserTypeLocal, defaultpracticeId, token]);

  useEffect(() => {
    if (photoUrl && photoUrl !== null) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/PatientDocument/DownloadAWSFile?path=${photoUrl}`,
          {
            headers,
            responseType: "blob",
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response]));
          setImagebase64(url);
        })
        .catch((error) => {
          console.error("There was an error fetching profile image!", error);
        });
    }
  }, [photoUrl]);

  useEffect(() => {
    if (profileModal && _userId) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Users/getUserById?id=${_userId}`,
          { headers }
        )
        .then((res) => {
          const responseData = res.data || res;
          console.log(responseData, "responseData");
          setUserData(responseData);
          Object.keys(responseData).forEach((field) => {
            setValue(field, responseData[field] || "");
          });
          if (responseData.password) {
            setValue("confirmPassword", responseData.password);
          }
        })
        .catch((error) => {
          console.error("Error fetching user:", error);
        });
    }
  }, [profileModal, _userId]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/Users/getUsers`, { headers })
      .then((response) => {
        setLoading(false);
        const data = response;
        setRows(data);
        const adminNames = data
          .filter((user) => user.userType === "Admin")
          .map((user) => user.fullName);

        setAdmins(adminNames);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching users:", error);
      });
  }, [refresh]);

  const validationSchema = Yup.object({
    fullName: Yup.string().required("Full Name is required"),
    userName: Yup.string().required("User Name is required"),
    email: Yup.string().required("Email is required").email("Email is invalid"),
    password: Yup.string().min(3, "Password must be at least 3 characters"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Passwords do not match")
      .required("Confirm Password is required"),
  });

  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    if (data.password && data.password !== data.confirmPassword) {
      return;
    }

    const postData = { ...data, id: _userId };

    // If password field is empty or unchanged, use the original password from userData
    if (!data.password || data.password === userData?.password) {
      delete postData.password;
      delete postData.confirmPassword;
      if (userData?.password) {
        postData.password = userData.password; // Use original password as is
      }
    } else {
      // If password is changed, hash the new password
      postData.password = md5(data.password);
      postData.confirmPassword = md5(data.confirmPassword);
    }

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Users/userRegistration`,
        postData,
        { headers }
      )
      .then((response) => {
        if (response.data?.id > 0 || response.id > 0) {
          axios
            .get(
              `${process.env.REACT_APP_API_URL}/Users/getUserById?id=${_userId}`,
              { headers }
            )
            .then((res) => {
              const responseData = res.data || res;
              setUserData(responseData);
              Object.keys(responseData).forEach((field) => {
                setValue(field, responseData[field] || "");
              });
              if (responseData.password) {
                setValue("confirmPassword", responseData.password);
              }
            });
          setProfileModal(false);
        }
      })
      .catch((error) => {
        console.error("Error updating user:", error);
      });
  };

  const handleCancel = () => {
    setProfileModal(false);
    if (userData) {
      Object.keys(userData).forEach((field) => {
        setValue(field, userData[field] || "");
      });
      if (userData.password) {
        setValue("confirmPassword", userData.password);
      }
    }
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={Imagebase64 || "/default-avatar.png"}
            alt="Profile"
          />
          <span className="d-none d-xl-inline-block ms-2 me-2">
            {userNameLocal}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <Typography
            style={{
              color: "#000000",
              fontWeight: "bold",
              fontSize: "15px",
              backgroundColor: "#e8f5e8",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "35px",
            }}
          >
            {UserTypeLocal}
          </Typography>
          <DropdownItem onClick={() => setProfileModal(true)}>
            <i className="ri-user-line align-middle me-2" />
            {props.t("Profile")}
          </DropdownItem>
          <Link to="/logout" className="dropdown-item">
            <i className="ri-shut-down-line align-middle me-2 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>

      <Modal
        isOpen={profileModal}
        toggle={() => setProfileModal(false)}
        size="lg"
      >
        <ModalHeader toggle={() => setProfileModal(false)}>
          <Typography
            variant="h6"
            fontWeight="bold"
            color="primary"
            sx={{ color: "#2e7d32" }}
          >
            User Profile
          </Typography>
        </ModalHeader>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            {userData ? (
              <Container>
                <Row>
                  <Col md={4}>
                    <Avatar
                      src={Imagebase64 || "/default-avatar.png"}
                      alt="Profile"
                      sx={{
                        width: 120,
                        height: 120,
                        mx: "auto",
                        border: "4px solid #2e7d32",
                        backgroundColor: "#e8f5e8",
                      }}
                    />
                  </Col>
                  <Col md={8}>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      sx={{ color: "#2e7d32" }}
                    >
                      {userData.fullName || userData.userName}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ color: "#424242" }}
                    >
                      {userData.email}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#388e3c" }}>
                      {userData.userType}
                    </Typography>
                     <Typography variant="body2" sx={{ color: "#000000ff" }}>
                      Efax #:{EfaxLocal || "N/A"}
                    </Typography>
                  </Col>
                </Row>

                <Box mt={4}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        sx={{ color: "#2e7d32" }}
                      >
                        Full Name:
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#424242" }}>
                        {userData.fullName || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        sx={{ color: "#2e7d32" }}
                      >
                        Email:
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#424242" }}>
                        {userData.email || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        sx={{ color: "#2e7d32" }}
                      >
                        User Name:
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#424242" }}>
                        {userData.userName || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        sx={{ color: "#2e7d32" }}
                      >
                        Address:
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#424242" }}>
                        {userData.address || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        sx={{ color: "#2e7d32" }}
                      >
                        State:
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#424242" }}>
                        {userData.state || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        sx={{ color: "#2e7d32" }}
                      >
                        ZIP Code:
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#424242" }}>
                        {userData.zipCode || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        sx={{ color: "#2e7d32" }}
                      >
                        City:
                      </Typography>

                      <Typography variant="body2" sx={{ color: "#424242" }}>
                        {userData.city || "N/A"}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} style={{ display: "flex" }}>
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        sx={{ color: "#2e7d32" }}
                      >
                        Password reset/News
                      </Typography>
                      <Checkbox
                        name="resetPassword"
                        // checked={sleepiness ? true : false}
                        checked={NewsLetters ? true : false}
                        onClick={() => {
                          setValue("resetPassword", !NewsLetters);
                          setNewsLetters(!NewsLetters);
                        }}
                        style={{ marginTop: "-10px" }}
                      />
                    </Grid>
                  </Grid>
                </Box>

                <Grid item xs={12} sm={6} md={4} style={{ marginTop: "20px" }}>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="rights-content"
                      id="rights-header"
                      style={{ color: "#2e7d32", backgroundColor: "#f1f8e9" }}
                    >
                      <Typography
                        style={{
                          fontSize: "25px",
                          fontWeight: "bold",
                          marginTop: 3,
                        }}
                      >
                        Admins List
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        {rows
                          .filter((user) => user.userType === "Admin")
                          .map((user, index) => (
                            <Grid item key={user.id}>
                              <Tooltip
                                title={user.email}
                                arrow
                                placement="top"
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: "16px", // email ka font bara
                                      fontWeight: "bold",
                                    },
                                  },
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    background: "#e0f2f1",
                                    padding: "6px 12px",
                                    borderRadius: "8px",
                                    boxShadow: 1,
                                    cursor: "pointer",
                                    transition: "0.3s",
                                    "&:hover": {
                                      background: "green",
                                      color: "white",
                                    }, // hover par green
                                  }}
                                >
                                  {index + 1}. {user.fullName}
                                </Typography>
                              </Tooltip>
                            </Grid>
                          ))}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>

                <Grid item xs={12} sm={6} md={4} style={{ marginTop: "20px" }}>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="rights-content"
                      id="rights-header"
                      style={{ color: "#2e7d32", backgroundColor: "#f1f8e9" }}
                    >
                      <Typography
                        style={{
                          fontSize: "25px",
                          fontWeight: "bold",
                          marginTop: 3,
                        }}
                      >
                        Change Password
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                     
                        <CardContent>
                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            sx={{ color: "#2e7d32" }}
                            gutterBottom
                          >
                            Change Password
                          </Typography>

                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <Typography
                                fontWeight="bold"
                                sx={{ color: "#2e7d32" }}
                                gutterBottom
                              >
                                Password
                              </Typography>
                              <Controller
                                name="password"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    type={showPassword ? "text" : "password"}
                                    size="small"
                                    fullWidth
                                    error={!!errors.password}
                                    helperText={errors.password?.message}
                                    sx={{
                                      "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                          borderColor: "#2e7d32",
                                        },
                                        "&:hover fieldset": {
                                          borderColor: "#1b5e20",
                                        },
                                        "&.Mui-focused fieldset": {
                                          borderColor: "#2e7d32",
                                        },
                                      },
                                    }}
                                    onChange={(e) => {
                                      field.onChange(e); // react-hook-form ko update karne ke liye
                                      setShowButton(true); // Save button ko show karne ke liye
                                    }}
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <Lock sx={{ color: "#2e7d32" }} />
                                        </InputAdornment>
                                      ),
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() =>
                                              setShowPassword(!showPassword)
                                            }
                                            edge="end"
                                            sx={{ color: "#2e7d32" }}
                                          >
                                            {showPassword ? (
                                              <VisibilityOff />
                                            ) : (
                                              <Visibility />
                                            )}
                                          </IconButton>
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography
                                fontWeight="bold"
                                sx={{ color: "#2e7d32" }}
                                gutterBottom
                              >
                                Confirm Password
                              </Typography>
                              <Controller
                                name="confirmPassword"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    type={
                                      showConfirmPassword ? "text" : "password"
                                    }
                                    size="small"
                                    fullWidth
                                    error={!!errors.confirmPassword}
                                    helperText={errors.confirmPassword?.message}
                                    sx={{
                                      "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                          borderColor: "#2e7d32",
                                        },
                                        "&:hover fieldset": {
                                          borderColor: "#1b5e20",
                                        },
                                        "&.Mui-focused fieldset": {
                                          borderColor: "#2e7d32",
                                        },
                                      },
                                    }}
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <Lock sx={{ color: "#2e7d32" }} />
                                        </InputAdornment>
                                      ),
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <IconButton
                                            aria-label="toggle confirm password visibility"
                                            onClick={() =>
                                              setShowConfirmPassword(
                                                !showConfirmPassword
                                              )
                                            }
                                            edge="end"
                                            sx={{ color: "#2e7d32" }}
                                          >
                                            {showConfirmPassword ? (
                                              <VisibilityOff />
                                            ) : (
                                              <Visibility />
                                            )}
                                          </IconButton>
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                )}
                              />
                            </Grid>
                          </Grid>
                        </CardContent>
                      
                      {showButton && (
                        <ModalFooter>
                          <Button
                            color="secondary"
                            type="button"
                            onClick={handleCancel}
                            sx={{
                              backgroundColor: "#f5f5f5",
                              color: "#757575",
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            color="primary"
                            type="submit"
                            sx={{
                              background:
                                "linear-gradient(to right, #165baaff, #6EB5FF)",
                            }}
                          >
                            Save
                          </Button>
                        </ModalFooter>
                      )}
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid item xs={12} sm={6} md={4} style={{ marginTop: "20px" }}>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="rights-content"
                      id="rights-header"
                      style={{ color: "#2e7d32", backgroundColor: "#f1f8e9" }}
                    >
                      <Typography
                        style={{
                          fontSize: "25px",
                          fontWeight: "bold",
                          marginTop: 3,
                        }}
                      >
                        Rights
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Rights notShow={true} RolesId={roleId} />
                    </AccordionDetails>
                  </Accordion>
                </Grid>

                <Divider sx={{ my: 2, borderColor: "#e0e0e0" }} />
              </Container>
            ) : (
              <Typography
                align="center"
                color="text.secondary"
                sx={{ color: "#9e9e9e" }}
              >
                Loading...
              </Typography>
            )}
          </ModalBody>
        </form>
      </Modal>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { error, success } = state.profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
